import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import axiosInstance from '../../axiosConfig';

const fetchMpCatalogues = async (params) => {
  const response = await axiosInstance.get('/mp_catalogues/', {
    params,
  });
  return response.data;
};

export const useGetMpCatalogues = (params = {}, options = {}) => {
  const queryParams = useMemo(() => {
    const out = {};
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') out[k] = v;
    });
    return out;
  }, [params]);

  const { data, error, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['mpCatalogues', queryParams],
    queryFn: () => fetchMpCatalogues(queryParams),
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
    // Keep the previous page visible while the next one loads.
    placeholderData: keepPreviousData,
  });

  const mpCatalogues = data?.results;
  const count = data?.count;
  const next = data?.next;
  const previous = data?.previous;

  return {
    mpCatalogues,
    count,
    next,
    previous,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
